module.exports = __webpack_public_path__ + "img/202312_02.a2a10f15.jpg";